document.addEventListener('livewire:navigated', function() {
    if (window.Toast) {
        window.addEventListener('toast', event => {
            const { type, message, errors } = event.detail;

            if (errors && errors.length > 0) {
                Toast.fire({
                    icon: 'error',
                    title: 'There were some errors',
                    html: '<ul>' + errors.map(error => `<li>${error}</li>`).join('') + '</ul>',
                });
            } else {
                Toast.fire({
                    icon: type,
                    title: message,
                });
            }
        });
    }
});
